// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2W-lx","title":"Header_title__1gNCi","side":"Header_side__2Jj3G"};